<template>
    <div>
       <HeaderTeam header="รายงานและการสรุปยอด" :img_header="header_image" link_back="reportwork"/>
       <MenuTeamReportAndSummaryList/>
       <DetailOrEditReportWorkList/>
    </div>
</template>

<script>
import HeaderImage from '@/assets/dashboard.png'
import HeaderTeam from '@/components/menuadmin/team/teamheader/HeaderTeam.vue'
import MenuTeamReportAndSummaryList from '@/components/menuadmin/team/teamreportandsummary/MenuTeamReportAndSummaryList.vue'
import DetailOrEditReportWorkList from '@/components/menuadmin/team/teamreportandsummary/DetailOrEditReportWorkList.vue'
export default {
    name:'editEmployeeSummary',
    components:{
        HeaderTeam,
        MenuTeamReportAndSummaryList,
        DetailOrEditReportWorkList,
    },
    data(){
        return{
            header_image:HeaderImage
        }
    }
}
</script>